import { actions } from "../../../assets";

export const columns = [
  //"Appointment ID",
  "Patient Name",
  "Patient ID",
  "Date",
  "Time",
  "Appointment Category",
  "Appointment Mode",
  "Appointment Status",
  "Actions",
];

export const patientAppointmentColumn = [
  //"Appointment ID",
  "Doctor",
  "Date",
  "Time",
  "Appointment Category",
  "Appointment Mode",
  "Appointment Status",
  "Actions",
];

export const patientTableColumns = [
  "Patient Name",
  "Patient ID",
  "Phone Number",
  "Category",
  "Actions",
];

export const rows = [
  {
    "Patient Name": "Micheal Jackson",
    "Patient ID": "22334455",
    Date: "12/20/2024",
    Time: "10:30am",
    "Appointment Type": "Online",
    Actions: actions,
  },
  {
    "Patient Name": "Barrack Obama",
    "Patient ID": "22334456",
    Date: "12/20/2024",
    Time: "10:30am",
    "Appointment Type": "Offline",
    Actions: actions,
  },
  {
    "Patient Name": "Cristiano Ronaldo",
    "Patient ID": "22334457",
    Date: "12/20/2024",
    Time: "10:30am",
    "Appointment Type": "Online",
    Actions: actions,
  },
  {
    "Patient Name": "Raheem Sterling",
    "Patient ID": "22334458",
    Date: "12/20/2024",
    Time: "10:30am",
    "Appointment Type": "Offline",
    Actions: actions,
  },
];

export const patientTablerows = [
  {
    "Patient Name": "Micheal Jackson",
    "Patient ID": "22334455",
    "Phone number": "09056133862",
    Category: "High risk",
    Actions: actions,
  },
  {
    "Patient Name": "Barrack Obama",
    "Patient ID": "22334456",
    "Phone number": "09056133862",
    Category: "Low risk",
    Actions: actions,
  },
  {
    "Patient Name": "Cristiano Ronaldo",
    "Patient ID": "22334457",
    "Phone number": "09056133862",
    Category: "Medium risk",
    Actions: actions,
  },
  {
    "Patient Name": "Raheem Sterling",
    "Patient ID": "22334458",
    "Phone number": "09056133862",
    Category: "Inactive",
    Actions: actions,
  },
];

export const initialStateValue = {
  patientId: "",
  doctorName: "",
  appointmentType: { category: "Initial", mode: "Online" }, // ✅ FIX: Correct type
  appointmentStatus: "",
  date: "",
  endTime: "",
  notes: "",
  address: "",
  startTime: "",
};
export const updateStateValue = {
  appointmentId: "",
  patientId: "",
  doctorName: "",
  appointmentType: { category: "Initial", mode: "Online" }, // ✅ FIX: Correct type
  appointmentStatus: "",
  date: "",
  endTime: "",
  notes: "",
  address: "",
  startTime: "",
};
